/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PermalinkViewContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_settings" | "ReplyListContainer1_settings" | "UserBoxContainer_settings">;
    readonly " $refType": "PermalinkViewContainer_settings";
};
export type PermalinkViewContainer_settings$data = PermalinkViewContainer_settings;
export type PermalinkViewContainer_settings$key = {
    readonly " $data"?: PermalinkViewContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkViewContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkViewContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '47cb723f1f2e7459aafc82f727c62dac';
export default node;
